<ng-container *ngIf="messages$ | async"></ng-container>

<div class="scaffold-sidebar-overlay">
  <div style="display: flex">
    <div style="flex: 1">
      <h3 class="scaffold-editor-panel-heading">
        {{ 'notifications' | translation }}
      </h3>
      <p
        class="scaffold-editor-panel-content scaffold-editor-panel-content--italic scaffold-editor-panel-content--grey">
        {{ 'notifications_menu_intro' | translation }}
      </p>

      <div *ngIf="newMessages?.length || oldMessages?.length">
        <button severity="secondary" (click)="clearAll()" pButton>
          {{ 'notifications_clear' | translation }}
        </button>
      </div>

      <div *ngIf="newMessages?.length">
        <h3 class="scaffold-editor-panel-heading">{{ 'new' | translation }}</h3>

        <scaffold-notification-message
          *ngFor="let message of newMessages; let i = index"
          [message]="message"
          [shouldHaveBorderBottom]="i < newMessages.length - 1"
          (closeNotification)="
            closeNotification($event)
          "></scaffold-notification-message>
      </div>

      <div *ngIf="oldMessages?.length">
        <h3 class="scaffold-editor-panel-heading">
          {{ 'earlier' | translation }}
        </h3>
        <scaffold-notification-message
          *ngFor="let message of oldMessages; let i = index"
          [message]="message"
          [shouldHaveBorderBottom]="i < oldMessages.length - 1"
          (closeNotification)="
            closeNotification($event)
          "></scaffold-notification-message>
      </div>
    </div>
    <div>
      <p-button
        class="scaffold-notification-close-btn"
        severity="contrast"
        variant="text"
        (click)="close()"
        aria-label="Close notifications panel">
        <i class="fa-solid fa-xmark"></i>
      </p-button>
    </div>
  </div>
</div>
